import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
import { ModalHeader } from './modal-header';
import { renderAndMountComponent } from '@wix/answers-lib';
// tslint:disable-next-line: max-line-length
import { createLinkButtonLegacyDriver } from '../../deprecated-buttons/deprecated-link-button/link-button.legacy-driver';
export var createModalHeaderDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.modal-header', ModalHeader.name);
    return {
        clickBack: function () { return createLinkButtonLegacyDriver(baseDriver.elem).click(); },
    };
};
export var createModalHeader = function (props) {
    var elem = renderAndMountComponent(React.createElement(ModalHeader, __assign({}, props)));
    return createModalHeaderDriver(elem);
};
//# sourceMappingURL=modal-header.driver.js.map